import React, { useMemo } from 'react'
import Image from 'next/image'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

import { convertToSlug } from 'utils/text'

type AnnouncementBannerProps = {
  title: string
  description: string
  linkHref?: string
  linkText?: string
}

export function AnnouncementBanner({
  title,
  description,
  linkHref,
  linkText,
}: AnnouncementBannerProps) {
  const { titleId, descriptionId } = useMemo(() => {
    const slugifiedTitle = convertToSlug(title)
    const id = `announcement-banner-${slugifiedTitle}`

    return {
      titleId: `${id}-title`,
      descriptionId: `${id}-description`,
    }
  }, [title])

  return (
    <article
      className="flex gap-6 p-6 shadow-card bg-white rounded-lg"
      role="region"
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
    >
      <div className="flex-shrink-0" aria-hidden="true">
        <Image
          alt=""
          src="/illustrations/img-announcement-speaker.png"
          width={84}
          height={84}
          className="flex-shrink-0"
          aria-hidden="true"
        />
      </div>
      <div className="flex flex-col gap-1 items-start">
        <Text variant="heading-sm" as="h2" id={titleId}>
          {title}
        </Text>
        <Text variant="body" id={descriptionId}>
          {description}
        </Text>
        {linkHref && linkText && (
          <Button
            variant="ghost"
            size="sm"
            as="a"
            type={undefined}
            href={linkHref}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`${linkText} (Buka di tab baru)`}
            className="flex-shrink-0 -ml-2 hover:!bg-transparent"
          >
            {linkText}
          </Button>
        )}
      </div>
    </article>
  )
}
